export default __webpack_public_path__ + "static/production4-8bb4f2f3364c1f9b0a73c5a6a17db168.jpg";